import NewsletterSignupCard from './NewsletterSignupCard';
import { NewsletterSignupFragmentFragment } from '../../__generated__/graphql';
import Section from '../../layout/Section';
import { ContentBlock } from '../types';

const NewsletterSignup: ContentBlock<NewsletterSignupFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.newsletterSignup;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <Section
      backgroundColor={contentBlockProps.darkBackground ? 'black' : 'white'}
      id={contentBlockProps.sectionId}
    >
      <NewsletterSignupCard
        darkBackground={!!contentBlockProps.darkBackground}
        description={contentBlockProps.description}
        image={contentBlockProps.image}
        marketoFormId={contentBlockProps.marketoFormId}
        successMessage={contentBlockProps.successMessage}
        successUrl={contentBlockProps.successUrl}
        title={contentBlockProps.title}
      />
    </Section>
  );
};
export default NewsletterSignup;
